import {
  HttpEvent,
  HttpHandler,
  HttpHeaders,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http'
import { Injectable, inject } from '@angular/core'
import { Store } from '@ngxs/store'
import { Observable } from 'rxjs'
import { UserMetaState } from '../store/user/user.meta.state'
export const InterceptorSkip = 'X-Skip-Interceptor'
export const InterceptorSkipHeader = new HttpHeaders({
  'X-Skip-Interceptor': '',
})

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  private store = inject(Store)
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    if (request.headers && request.headers.has(InterceptorSkip)) {
      const headers = request.headers.delete(InterceptorSkip)
      return next.handle(request.clone({ headers }))
    }
    const token = this.store.selectSnapshot(UserMetaState.getUserToken)

    const authRequest = request.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
      },
    })

    return next.handle(authRequest)
  }
}
